import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocationErrorHandler } from '../location/location-error-handler';
import { LBSErrorHandler } from './error-handler';
import { LBSErrorHandlerService } from './error-handler.service';
import { ExtFileErrorErrorHandler } from '../ext-files/logic/ext-file-error-handler';
import { FormFieldErrorHandler } from 'src/app/_components/dyn-form/form-field-error-handler';
import { RestErrorHandler } from './error-handlers/rest-error-handler';
import { ConnectionErrorHandler } from './error-handlers/connection-error-handler';
import { PeripheralErrorHandler } from '../peripherals/logic/peripheral-error-handler';
import { TerminalErrorHandler } from '../peripherals/logic/terminal-error-handler';
import { BarcodeServiceErrorHandler } from '../barcode/barcode-error-handler';
import { DraftAlreadyTakenOverErrorHandler } from './error-handlers/draft-already-taken-over-error-handler';
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: LBSErrorHandler,
      useExisting: LocationErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: ExtFileErrorErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: FormFieldErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: DraftAlreadyTakenOverErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: ConnectionErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: RestErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: PeripheralErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: TerminalErrorHandler,
      multi: true,
    },
    {
      provide: LBSErrorHandler,
      useExisting: BarcodeServiceErrorHandler,
      multi: true,
    },
    LBSErrorHandlerService,
  ],
})
export class LBSErrorHandlerModule {}
